// Configuração de ambiente para Web Push
export const ENV_CONFIG = {
  // Chave VAPID pública para Web Push
  VAPID_PUBLIC_KEY: 'BIfXcV58W3OO7QYCf7F7rWSnd42roAvDKPR-ndob47HMvm8siGTegQAsUr9ZBwt7tO87krrdLvEdQKvJB06gIWA',
  
  // URL da API
  API_URL: 'https://api.vilablackrabbit.com.br',
  
  // Configurações de debug
  DEBUG_WEBPUSH: true,
  DEBUG_SERVICE_WORKER: true
};

// Função para obter a chave VAPID
export const getVapidKey = (): string => {
  return process.env.REACT_APP_VAPID_PUBLIC_KEY || ENV_CONFIG.VAPID_PUBLIC_KEY;
};

// Função para obter a URL da API
export const getApiUrl = (): string => {
  return process.env.REACT_APP_API_URL || ENV_CONFIG.API_URL;
};
